/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/modules/material.module';

import { UIElementsModule } from '../../ui-elements/ui-elements.module';

@Component({
  selector: 'app-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.scss'],
  imports: [TranslateModule, UIElementsModule, MatIconModule, MaterialModule, MatDialogModule],
})
export class DialogContainerComponent {
  @HostBinding('attr.title') readonly suppressNativeTitleTooltip = null;

  @Input() title: string;
  @Input() subtitle: string;
  @Input() entityNameTitle: string;
  @Input() confirmButtonText = 'save';
  @Input() confirmButtonIcon = '';
  @Input() cancelButtonText = 'cancel';
  @Input() confirmButton: 'primary' | 'warn-secondary' = 'primary';
  @Input() confirmButtonDisabled = false;
  @Input() confirmButtonLoading = false;
  @Input() editButtonDisabled = false;
  @Input() isValid = true;
  @Input() form?: FormGroup | null;
  @Input() createPrivilege: string;
  @Input() editPrivilege: string;
  @Input() deletePrivilege: string;
  @Input() adminPrivilege: string;

  @Input() showCancelButton = true;
  @Input() showCloseButton = true;
  @Input() showConfirmButton = true;
  @Input() showDeleteButton = false;
  @Input() hideActionsSeparator = false;
  @Input()
  @HostBinding('class.scrollable-body')
  scrollableBody = false;

  @Output() readonly confirmButtonHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() readonly deleteButtonHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() readonly editButtonHandler: EventEmitter<any> = new EventEmitter<any>();

  get confirmButtonType(): 'raised' | 'stroked' {
    return this.confirmButton === 'warn-secondary' ? 'stroked' : 'raised';
  }

  get confirmButtonColor(): 'primary' | 'warn' {
    return this.confirmButton === 'warn-secondary' ? 'warn' : 'primary';
  }

  constructor(private dialogRef: MatDialogRef<DialogContainerComponent>) {}

  get shouldShowActions(): boolean {
    if (this.form?.disabled) {
      return true;
    }

    return this.showCancelButton || this.showConfirmButton;
  }

  confirm(): void {
    this.form?.markAllAsTouched();

    if (this.isValid) {
      this.dialogRef.close(true);
    }
    this.confirmButtonHandler.emit(true);
  }

  edit(): void {
    this.editButtonHandler.emit(true);
  }

  delete(): void {
    this.deleteButtonHandler.emit(true);
  }
}
